import type { RequestParameters, Variables } from 'relay-runtime';

import { logger } from '@townsquare/logging/logger';

const VARIABLE_PARAMS_TO_CHECK = ['workspaceUUID', 'workspaceUuid'];
export const captureMissingWorkspaceUuid = (
	request: RequestParameters,
	variables: Variables,
): void => {
	VARIABLE_PARAMS_TO_CHECK.forEach((param) => {
		if (param in variables && (variables[param] === null || variables[param] === '')) {
			logger.error(
				'InvalidGraphQLRequestException: Tried to make GraphQL request with missing workspaceUuid when needed',
				{
					tags: {
						operationName: request.name,
					},
					extra: {
						requestVariables: variables,
					},
				},
			);
		}
	});
};
